import React from "react";
import { connect } from "react-redux";
import { Typography as Typo } from "@material-ui/core";
import "./post.style.scss";
import "../galleryStyles.scss";

export class Post extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      url: "",
    };
  }

  componentDidMount() {
    // Load Data from redux
    if (!this.state.title && !this.state.url && !this.state.description) {
      const postInfo = this.props.Gallery.currentPost;
      this.props.dispatch({
        type: "DEL_POST",
      });
      if (!Object.keys(postInfo)) {
        this.props.history.push("/gallery");
      } else {
        this.setState({
          title: postInfo.title,
          description: postInfo.description,
          url: postInfo.url,
        });
      }
    }
  }

  render() {
    return (
      <div className={"row mt-sm-2 fadeUpAn"}>
        <div className="col-12">
          <div className="row">
            <div className="col-12 pt-5">
              <div className="text-center w-100 h-75">
                <img
                  src={this.state.url}
                  alt="sdaaaa"
                  className="w-100 h-100 rounded shadow"
                />
                <Typo className="p-3 font-weight-bold" variant="h4">
                  {this.state.title}
                </Typo>
              </div>
            </div>
          </div>
          <div className="row p-2 mt-3"></div>
          <div className="row">
            <div className="col-md-10 m-auto border-right">
              {this.state.description.split("\n").map((line, index) => (
                <Typo
                  key={`line-${index}`}
                  className="p-3"
                  variant={line.startsWith("*") ? "h6" : "body1"}
                >
                  {line.replaceAll("*", "")}
                </Typo>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => state;
export default connect(mapStateToProps)(Post);
